//import { param2Obj } from 'utils';
const userInfo = {
  code: 0,
  data: {
    token: 'admin',
    name: 'Super Admin',
    account: 'goldprog@163.com',
    bindEmail: false
  },
  message: 'success'
}


export default {
  loginByAccount: config => {
    return userInfo
  },
  // getInfo: config => {
  //   const { token } = param2Obj(config.url);
  //   if (userMap[token]) {
  //     return userMap[token];
  //   } else {
  //     return Promise.reject('a');
  //   }
  // },
  logout: () => {
    return '退出成功'
  }
};



// WEBPACK FOOTER //
// ./src/mock/login.js